import { createSelector } from '@ngrx/store';
import { AppState } from '../reducers';
import * as fromClient from './client.reducer';

export const selectClient = (state: AppState) => state.client;

export const invalidVersionAlertDisplayInitiated = createSelector(
	selectClient,
	(state: fromClient.State) => state.invalidVersionAlertDisplayInitiated
);